import { render, staticRenderFns } from "./ModalEditItem.vue?vue&type=template&id=35a73812"
import script from "./ModalEditItem.vue?vue&type=script&lang=js"
export * from "./ModalEditItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports